module.exports = __webpack_public_path__ + "static/media/path1.e3bcdea1.jpg";